import { connect } from 'react-redux';
import UserGroups from './UserGroups';
import { STATE_ROOT } from '../../../../../redux';

const mapStateToProps = state => ({
  app: state[STATE_ROOT].apps.details.settings.settings,
  isLoading: state.accessControl.app.userGroupsPermissions.isLoading,
  permissions: state.accessControl.app.userGroupsPermissions.permissions,
  total: state.accessControl.app.userGroupsPermissions.total,
  failed: state.accessControl.app.userGroupsPermissions.failed,
});

export default connect(mapStateToProps, null)(UserGroups);
